import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Select, Alert, DatePicker } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { connect } from 'react-redux';
import moment from 'moment';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	supplierFacilitiesRestCrudThunksForBuyer,
} from '../../thunks/supplier_facilities_thunks';

const FormItem = Form.Item;
export const DATE_FORMAT = 'MMMM D, YYYY h:mm a';

interface ScheduleWalkthroughProps {
	onSubmit: any;
	onCancel: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;

	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	supplierFacilities: any;
	creating: boolean;
	updating: boolean;
	formData: any;
}

interface ScheduleWalkthroughFormProps extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;

	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	supplierFacilities: any;
	creating: boolean;
	updating: boolean;
	formData: any;
}

const disabledDate = (current) => {
	// Can not select days before today and today
	return current < moment().startOf('day');
};

class ScheduleWalkthroughModalForm extends React.Component<ScheduleWalkthroughFormProps, any> {
	render() {
		const {
			visible,
			fetchMultipleSupplierFacilitiesInPrivateNetwork,
			fetchSupplierFacilitiesInPrivateNetwork,
			supplierFacilities,
			onCancel,
			onSubmit,
			form,
			formData,
			createErrors,
			updateErrors,
		} = this.props;
		const { getFieldDecorator } = form;
		const okText = 'Schedule';
		const titleText = 'Schedule Walkthrough';
		getFieldDecorator(`id`, { initialValue: formData.id });
		return (
			<Modal
				visible={visible}
				width={600}
				title={titleText}
				okText={okText}
				onCancel={onCancel}
				onOk={onSubmit}
				closable={false}
			>
				<Form layout="vertical" className="supplierForm">
					{createErrors.length > 0 ? (
						<FormItem>
							<Alert message={createErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					{updateErrors.length > 0 ? (
						<FormItem>
							<Alert message={updateErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					<FormItem label="Due By">
						{getFieldDecorator(`dueAt`, {
							rules: [
								{
									type: 'object',
									required: true,
									message: 'Please select the walkthrough due date.',
								},
							],
							initialValue: formData.dueAt ? moment(formData.dueAt) : undefined,
						})(
							<DatePicker
								disabledDate={disabledDate}
								style={{ width: '100%' }}
								showTime={true}
								format={DATE_FORMAT}
							/>
						)}
					</FormItem>
					<Form.Item label="Supplier">
						{getFieldDecorator('supplierFacilityId', {
							initialValue: formData.supplierFacilityId,
						})(
							<OWAsyncSelect
								stateSlice={supplierFacilities}
								targetCollectionName="walkthroughSupplierFacilitiesInPrivateNetwork"
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
								}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchSupplierFacilitiesInPrivateNetwork(
										{ name: searchText, offset: 0, limit: 100 },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(supplierFacility) => (
									<Select.Option key={supplierFacility.id} value={supplierFacility.id}>
										{supplierFacility.name}
									</Select.Option>
								)}
							/>
						)}
					</Form.Item>
				</Form>
			</Modal>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	visible: ownProps.visible,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	createErrors: state.walkthroughs.createErrors,
	updateErrors: state.walkthroughs.updateErrors,
	creating: state.walkthroughs.creating,
	updating: state.walkthroughs.updating,
	supplierFacilities: state.supplier_facilities,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForBuyer(
				params,
				'walkthroughSupplierFacilitiesInPrivateNetwork'
			)
		),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Form.create<ScheduleWalkthroughFormProps>()(ScheduleWalkthroughModalForm));
